import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import type { KitAssetYouTube } from 'fym-shared/src/music24/addedAssets';
import { TypedMemo } from '../../../common/types';
import { onYouTubeBadgeText } from './youtubeViews';
/* eslint-disable css-modules/no-unused-class -- the badge row of the one-off channels; this badge uses its own slice */
import styles from '../publish/Publish.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The YouTube badge of a linked YouTube video (design music-video a5): the video is on YouTube
 * already, so the badge is always on and opens nothing to publish. It shows the views when we know
 * them.
 */
const OnYouTubeBadgeComponent: React.FC<{ youtube: KitAssetYouTube | null | undefined }> = ({ youtube }) => {
  const intl = useIntl();
  return (
    <div className={styles.badgeRow}>
      <span className={clsx(styles.badge, styles.badgeOn)} data-testid="youtube-linked-badge">
        <FontAwesomeIcon icon={faCheck} className="me-1" />
        {onYouTubeBadgeText(intl, youtube)}
      </span>
    </div>
  );
};

export const OnYouTubeBadge = TypedMemo(OnYouTubeBadgeComponent);
